import React from 'react';
import './GoalUnreachedMessage.scss';
const GoalUnreachedMessage = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "goal-not-reached"
  }, /*#__PURE__*/React.createElement("span", null, "UNFORTUNATELY,"), /*#__PURE__*/React.createElement("span", null, "GOAL WASN'T REACHED THIS TIME"));
});
GoalUnreachedMessage.displayName = 'GoalUnreachedMessage';
export default GoalUnreachedMessage;